<template>
  <v-card class="employee-menu">
    <div class="employee-search">
      <v-text-field
        v-model="searchStr"
        density="compact"
        hide-details
        placeholder="Пошук за ПІБ..."
        prepend-inner-icon="mdi-magnify"
        variant="plain"
        @click.stop />
    </div>

    <v-list class="bg-white scrollable-list" color="white" density="compact">
      <v-list-item
        v-for="item in filteredItems"
        :key="item.id"
        class="employee-item"
        color="blue-grey-lighten-5"
        @click="selectItem(item)">
        <template #prepend>
          <v-avatar :color="getAvatarColor(item.name)" size="32">
            {{ getInitials(item.name) }}
          </v-avatar>
        </template>

        <v-list-item-title class="employee-item__title">
          {{ item.name }}
        </v-list-item-title>

        <v-list-item-subtitle class="employee-item__subtitle">
          {{ keepArray(item.departments)[0]?.name || 'Департамент відсутній' }}
        </v-list-item-subtitle>
      </v-list-item>

      <v-list-item v-if="!filteredItems.length">
        <v-list-item-title class="text-grey">
          Нічого не знайдено
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script setup lang="ts">
import { getAvatarColor, getInitials } from './helpers'
import { computed, ref } from 'vue'
import { fillDirectory, getDirectory } from '@/directory'
import { UserLink } from '@/utils/types/user'
import { keepArray } from 'best-modules/utils'

defineOptions({
  name: 'EmployeeList',
})
const emit = defineEmits<{
  (_name: 'select', _user: UserLink): void
}>()

const searchStr = ref<string | null>(null)

fillDirectory('userList')

const filteredItems = computed<UserLink[]>(() => {
  if (searchStr.value) {
    return getDirectory('userList').filter(i =>
      i.name.toLowerCase().includes(searchStr.value.toLowerCase())
    ) as UserLink[]
  } else {
    return getDirectory('userList') as UserLink[]
  }
})

const selectItem = (user: UserLink) => {
  searchStr.value = null
  emit('select', user)
}
</script>
